import { SVGProps } from "react";
import { vars } from "~/styles/variables.css";

interface IProps extends SVGProps<SVGSVGElement> {}

export const Exclude = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 112 161"
      {...props}
    >
      <path
        fill={vars.desktop.semanticsBrandThemeNeutral01}
        d="M53.507 160.344h4.986L112 .344v160.001H0v-160zM0 .344h112z"
        clipRule="evenodd"
        fillRule="evenodd"
      />
    </svg>
  );
};
